// Utility to get full image URL
const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export function getImageUrl(imageUrl) {
  if (!imageUrl) return null;
  
  // If it's already a full URL (http/https), return as is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }
  
  // If it's a relative URL starting with /api/uploads, prepend the API URL
  if (imageUrl.startsWith('/api/uploads/')) {
    return `${API_URL}${imageUrl}`;
  }
  
  // If it's just /uploads/, add /api prefix and prepend API URL
  if (imageUrl.startsWith('/uploads/')) {
    return `${API_URL}/api${imageUrl}`;
  }
  
  // Otherwise, assume it's a filename and construct the full path
  return `${API_URL}/api/uploads/${imageUrl}`;
}

export function getEngineImage(engine, index = 0) {
  const defaultImage = 'https://images.pexels.com/photos/3862132/pexels-photo-3862132.jpeg?auto=compress&cs=tinysrgb&w=800';
  
  if (!engine?.images || engine.images.length === 0) {
    return defaultImage;
  }
  
  const image = engine.images[index] || engine.images[0];
  return getImageUrl(image) || defaultImage;
}
